// Control which shows a link button to toggle visibility of a panel
// displaying all raster:bands values of an asset.

import { IconButton, Panel, PanelType, Separator } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { stacFormatter, safeFormat } from "utils/stac";
import { ASSET_DETAIL_KEYS } from "./ItemAssets";
import React from "react";

interface AssetDetailsProps {
  asset: Record<string, any>;
}

const AssetDetails = ({ asset }: AssetDetailsProps) => {
  const [isOpen, { setTrue, setFalse }] = useBoolean(false);

  const formattedSections = ASSET_DETAIL_KEYS.map(key => ({
    key,
    detail: asset[key],
  }))
    .filter(detail => Boolean(detail.detail))
    .map(({ key, detail }) => {
      return (
        <React.Fragment key={`asset-detail-${key}`}>
          <strong>{stacFormatter.label(key)}</strong>
          {safeFormat(detail, key)}
        </React.Fragment>
      );
    });

  if (formattedSections.length === 0) return null;

  return (
    <>
      <IconButton
        iconProps={{ iconName: "Info" }}
        title="Show asset details"
        onClick={setTrue}
        styles={{ root: { height: 16 } }}
      />
      <Panel
        type={PanelType.custom}
        customWidth={"450px"}
        headerText={asset.title || "Asset details"}
        isOpen={isOpen}
        isLightDismiss={true}
        onDismiss={setFalse}
        closeButtonAriaLabel="Close"
      >
        <Separator />
        {formattedSections}
      </Panel>
    </>
  );
};

export default AssetDetails;
